<a class="shop-tile-compact-link" [routerLink]="routerLink">
  <div class="shop-tile-compact-image">
    <div *ngIf="showTags" class="shop-tile-compact-image-tags">
      <div
        class="box-promo-tag"
        [reactComponent]="promoTagComponent"
        *ngIf="firstGroupTagOptions"
        [props]="{ options: firstGroupTagOptions, enableAnimations: true }"
      ></div>
      <div
        class="box-promo-tag"
        [reactComponent]="promoTagComponent"
        *ngIf="secondGroupTagOptions"
        [props]="{ options: secondGroupTagOptions, enableAnimations: true }"
      ></div>
    </div>
    <div
      class="image-tile hoverable-animated"
      [reactComponent]="imageTileComponent"
      [props]="{
        imgUrl: logoUrl,
        altText: name + ' logo',
        overlayText: disabledText,
        bottomOverlayText: hasTakeAwayLabel ? 'Take Away' : null,
        translate: translateReference
      }"
    ></div>
  </div>
  <div class="shop-tile-compact-details" [class.shop-tile-compact-details-disabled]="disabledText">
    <div *ngIf="showBadges" class="shop-tile-compact-details-badges">
      <div *ngIf="firstGroupBadgeOptions" [reactComponent]="promoBadgeComponent" [props]="firstGroupTagOptions"></div>
      <div
        *ngIf="secondGroupBadgeOptions"
        [reactComponent]="promoBadgeComponent"
        [props]="secondGroupBadgeOptions"
      ></div>
    </div>
    <div class="shop-tile-compact-info">
      <div
        class="shop-tile-compact-info-name shop-tile-compact-info-row"
        [class.shop-tile-compact-info-name-with-promoted-tag]="showPromotedTag && !showBadges"
        [title]="name"
      >
        {{ name }}
      </div>
      <div class="shop-tile-compact-info-row">
        <div class="shop-tile-compact-info-row-block shop-tile-compact-info-new-tag" *ngIf="isNew">NEW</div>
        <shop-rating *ngIf="showRating" class="shop-tile-compact-info-row-block" [shop]="shop"></shop-rating>
        <span class="shop-tile-compact-info-row-block shop-tile-compact-info-cuisine-text" [title]="cuisineText">{{
          cuisineText
        }}</span>
      </div>
      <div class="shop-tile-compact-info-row">
        <shop-tile-delivery-info [shop]="shop"></shop-tile-delivery-info>
      </div>
    </div>
    <span *ngIf="showPromotedTag" class="shop-tile-compact-details-promoted-tag">{{ promotedTag }}</span>
  </div>
</a>
